const toRad = (value) => (value * Math.PI) / 180;

export const calculateDistanceBetweenLocations = (loc1, loc2) => {
  const R = 6371e3; // Earth radius in meters
  const lat1 = Number(loc1.latitude);
  const lat2 = Number(loc2.latitude);
  const lon1 = Number(loc1.longitude);
  const lon2 = Number(loc2.longitude);

  const dLat = toRad(lat2 - lat1);
  const dLon = toRad(lon2 - lon1);

  const a =
    Math.sin(dLat / 2) ** 2 +
    Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLon / 2) ** 2;

  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

  return R * c; // Distance in meters
};
